import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'rmb-multiselect-edit',
  templateUrl: './multiselect-edit.component.html',
  styleUrl: './multiselect-edit.component.scss',
  standalone: false,
})
export class MultiselectEditComponent<T = unknown> {
  @Input() items: T[] = [];
  @Input() selectedItems: [] = [];
  @Output() selectAllClicked = new EventEmitter<void>();
  @Output() selectNoneClicked = new EventEmitter<void>();
  @Output() editClicked = new EventEmitter<void>();

  onSelectAll() {
    this.selectAllClicked.emit();
  }

  onSelectNone() {
    this.selectNoneClicked.emit();
  }

  onEditOpen() {
    this.editClicked.emit();
  }
}
